// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function fromString(user_roles_cookie) {
  return $$Array.to_list(user_roles_cookie.split("&"));
}

function user_roles_decode(adminJson) {
  return Belt_Result.map(Decco.stringFromJson(adminJson), fromString);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var adminJson = Belt_Option.getWithDefault(Js_dict.get(dict._0, "user_roles"), null);
  var user_roles = Belt_Result.map(Decco.stringFromJson(adminJson), fromString);
  if (user_roles.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              user_roles: user_roles._0
            }
          };
  }
  var e = user_roles._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".user_roles" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  fromString ,
  user_roles_decode ,
  t_decode ,
  
}
/* No side effect */
